export default "__VITE_ASSET__2789f089__"